import React from 'react';

interface IProps {
  text: string;
  className?: string;
}

const Title: React.FC<IProps> = ({ text, className }) => {
  return (
    <h6 className={` text-text-black capitalize ${className} `}>{text}</h6>
  );
};

export default React.memo(Title);
